'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactCssThemr = require('react-css-themr');

exports.default = _reactCssThemr.themr;
//# sourceMappingURL=themer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/theme-provider/lib/cjs/themer.js
 ** module id = 558
 ** module chunks = 1
 **/